export default "__VITE_ASSET__DQZXH68O__"